import {Box} from "@mui/material";
import {useLayoutEffect, useRef, useState} from "react";
import Quiz from "../components/quiz";
import {useAppDispatch, useAppSelector} from "../hooks/hooks";
import {setStep} from "../reducers/quizSlice";

const PASSWORD_STEP = 21;

const QuizPassword = () => {
  const dispatch = useAppDispatch();
  const currentStep = useAppSelector((state) => state.quiz.value);
  const previousState = useRef({
    quizFull: localStorage.getItem("quiz_full"),
    step: currentStep,
  });
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    localStorage.setItem("quiz_full", "1");
    dispatch(setStep(PASSWORD_STEP));
    setIsReady(true);

    return () => {
      const {quizFull, step} = previousState.current;
      if (quizFull === null) {
        localStorage.removeItem("quiz_full");
      } else {
        localStorage.setItem("quiz_full", quizFull);
      }
      dispatch(setStep(step));
    };
  }, [dispatch]);

  if (!isReady) {
    return null;
  }

  return (
    <Box sx={{margin: "0 auto", maxWidth: "560px", padding: "0 8px"}}>
      <Quiz/>
    </Box>
  );
};

export default QuizPassword;
